// extracted by mini-css-extract-plugin
export default {"outerContainer":"xqosp","sizing":"HXfpY","double":"v9zbN","imageContainer":"_203_3","imageBackground":"_3rorV","image":"_3mYDK"};